import script from "./RilevazioniEventi.vue?vue&type=script&setup=true&lang=js"
export * from "./RilevazioniEventi.vue?vue&type=script&setup=true&lang=js"

import "./RilevazioniEventi.vue?vue&type=style&index=0&id=63036196&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63036196"]])

export default __exports__